export default {
    custInfo : {},
    custBiz: {},
    custCntrctList: {},
}
